import { countries } from "../helpers/countries";
import { associatedGroup, beneficiaryGroup, detailedBeneficiaryGroup, detailsGroupCompact, fulfillmentGroup, historyGroup, insuredPersonGroupCompact, paymentGroup, policyGroup, policyGroupCompact } from "../helpers/fieldGroups";
import { applicantFields, basicContactFields, basicCoverageFields, legalGuardianFields, premiumField, schoolFields, studentNumberFields } from "../helpers/fields";
import { provinces } from "../helpers/provinces";

export function deprecatedClients() {
  return {
    bflvtc: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [...applicantFields('0')]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields()]
          },
          {
            group_name: 'Insured Person *++',
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            check_history: true,
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent'},
                  {value: 'travelling companion', text: 'Travelling Companion'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              }
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              },
              {
                key_path: ['application', 'additional_data', 'super_visa'],
                as: 'Are applicants travelling to Canada on a Super Visa?',
                type: 'radio',
                options: [
                  {value: 'no', text: 'No'},
                  {value: 'yes', text: 'Yes'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'super_visa'],
                    value: 'yes'
                  }
                ],
                key_path: ['application', 'additional_data', 'coverage'],
                as: 'Coverage',
                type: 'dropdown',
                options: [
                  {value: 100000, text: '$100,000.00 CAD'},
                  {value: 150000, text: '$150,000.00 CAD'},
                  {value: 300000, text: '$300,000.00 CAD'},
                  {value: 500000, text: '$500,000.00 CAD'},
                  {value: 1000000, text: '$1,000,000.00 CAD'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'super_visa'],
                    value: 'no'
                  }
                ],
                key_path: ['application', 'additional_data', 'coverage'],
                as: 'Coverage',
                type: 'dropdown',
                options: [
                  {value: 50000, text: '$50,000.00 CAD'},
                  {value: 100000, text: '$100,000.00 CAD'},
                  {value: 150000, text: '$150,000.00 CAD'},
                  {value: 300000, text: '$300,000.00 CAD'},
                  {value: 500000, text: '$500,000.00 CAD'},
                  {value: 1000000, text: '$1,000,000.00 CAD'}
                ]
              },
              {
                key_path: ['application', 'additional_data', 'deductible'],
                as: 'Deductible',
                type: 'dropdown',
                options: [
                  {value: 0, text: '$0.00 CAD'},
                  {value: 100, text: '$100.00 CAD'},
                  {value: 250, text: '$250.00 CAD'},
                  {value: 500, text: '$500.00 CAD'},
                  {value: 1000, text: '$1,000.00 CAD'},
                  {value: 3000, text: '$3,000.00 CAD'},
                  {value: 5000, text: '$5,000.00 CAD'},
                  {value: 10000, text: '$10,000.00 CAD'},
                  {value: 25000, text: '$25,000.00 CAD'}
                ]
              }
            ]
          },
          beneficiaryGroup(),
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    bflis: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              {
                key_path: ['applicant', '0', 'additional_data', 'school_name'],
                as: 'School'
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Permanent Residence',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields()]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {
                    value: 'spouse',
                    text: 'Spouse'
                  },
                  {
                    value: 'dependent child',
                    text: 'Dependent Child'
                  },
                  {
                    value: 'parent',
                    text: 'Parent'
                  },
                  {
                    value: 'legal guardian',
                    text: 'Legal Guardian'
                  },
                  {
                    value: 'teacher',
                    text: 'Teacher'
                  },
                  {
                    value: 'chaperone',
                    text: 'Chaperone'
                  }
                ]
              }
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [...basicCoverageFields()]
          },
          {
            group_name: 'Beneficiary Information',
            check_history: true,
            fields: [
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'beneficiary',
                  'first_name'
                ],
                as: 'First Name'
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'beneficiary',
                  'last_name'
                ],
                as: 'Last Name'
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'beneficiary',
                  'address'
                ],
                as: 'Address'
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'beneficiary',
                  'city'
                ],
                as: 'City'
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'beneficiary',
                  'country_code'
                ],
                as: 'Country',
                type: 'dropdown',
                options: countries()
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'beneficiary',
                  'relationship_to_insured'
                ],
                as: 'Relationship to Insured'
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleycanuckvoyage: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [...applicantFields('0')]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields()]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'travelling companion', text: 'Travelling Companion'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              }
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  },
                  {
                    key_path: [
                      'application',
                      'additional_data',
                      'additional_coverage'
                    ],
                    value: true
                  }
                ],
                key_path: ['application', 'departure_date'],
                as: 'Departure Date',
                format: 'date'
              },
              {
                key_path: ['application', 'additional_data', 'policy_type'],
                as: 'Policy Type',
                type: 'radio',
                options: [
                  {value: 'single trip', text: 'Single Trip'},
                  {value: 'multi-trip annual', text: 'Multi-Trip Annual'}
                ],
                is_static_by_default: true
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  },
                  {
                    key_path: [
                      'application',
                      'additional_data',
                      'additional_coverage'
                    ],
                    value: true
                  }
                ],
                key_path: ['application', 'additional_data', 'top_up'],
                as: 'Top Up',
                is_static_by_default: true
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  },
                  {
                    key_path: [
                      'application',
                      'additional_data',
                      'additional_coverage'
                    ],
                    value: true
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'days_of_coverage'
                ],
                as: 'Number of days covered by other insurance plan'
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  },
                  {
                    key_path: [
                      'application',
                      'additional_data',
                      'additional_coverage'
                    ],
                    value: true
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'additional_coverage_plan'
                ],
                as: 'Name of plan'
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  }
                ],
                key_path: ['application', 'additional_data', 'destination'],
                as: 'Destination',
                type: 'dropdown',
                options: countries()
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'multi-trip annual'
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'number_of_days_per_trip'
                ],
                as: 'Number of Days per Trip',
                type: 'dropdown',
                options: [
                  {value: 5, text: '5 Days'},
                  {value: 10, text: '10 Days'},
                  {value: 20, text: '20 Days'},
                  {value: 35, text: '35 Days'},
                  {value: 50, text: '50 Days'},
                  {value: 65, text: '65 Days'},
                  {value: 100, text: '100 Days'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  }
                ],
                do_not_show_if: [
                  {
                    key_path: ['application', 'additional_data', 'destination'],
                    value: 'US'
                  },
                  {
                    key_path: [
                      'application',
                      'additional_data',
                      'travelling_through_the_us'
                    ],
                    value: null
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'travelling_through_the_us'
                ],
                as: 'Are applicants travelling through the US?',
                type: 'radio',
                options: [
                  {value: 'no', text: 'No'},
                  {value: 'yes', text: 'Yes'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  },
                  {
                    key_path: [
                      'application',
                      'additional_data',
                      'travelling_through_the_us'
                    ],
                    value: 'yes'
                  }
                ],
                do_not_show_if: [
                  {
                    key_path: ['application', 'additional_data', 'destination'],
                    value: 'US'
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'number_of_travel_days_in_the_us'
                ],
                as: 'Number of Travel Days in the US'
              },
              {
                key_path: ['application', 'additional_data', 'deductible'],
                as: 'Deductible',
                type: 'dropdown',
                options: [
                  {value: 0, text: '$0.00 CAD'},
                  {value: 250, text: '$250.00 CAD'},
                  {value: 500, text: '$500.00 CAD'},
                  {value: 1000, text: '$1,000.00 CAD'},
                  {value: 5000, text: '$5,000.00 CAD'},
                  {value: 10000, text: '$10,000.00 CAD'}
                ]
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleycomprehensiveplus: {
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            },
            {
              value: 'print',
              label: 'Print Format'
            }
          ]
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              {
                key_path: ['application', 'additional_data', 'school_name'],
                as: 'School'
              },
              ...studentNumberFields('0'),
              ...premiumField('0'),
              {
                key_path: ['application', 'associated_policy'],
                as: 'Associated Student Policy',
                do_not_show_if: [
                  {
                    key_path: ['application', 'associated_policy'],
                    value: null
                  }
                ],
                is_static_by_default: false
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'relationship_to_student'
                ],
                as: 'Relationship to Student',
                do_not_show_if: [
                  {
                    key_path: ['application', 'associated_policy'],
                    value: null
                  }
                ],
                is_static_by_default: false,
                type: 'dropdown',
                options: [
                  {value: 'parent', text: 'Parent/Guardian'},
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'spouse', text: 'Spouse'},
                  {value: 'teacher', text: 'Teacher'},
                  {value: 'chaperone', text: 'Chaperone'}
                ]
              }
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(false)]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'parent', text: 'Parent/Guardian'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              },
              ...studentNumberFields('*'),
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              },
              {
                key_path: ['application', 'additional_data', 'other_plan'],
                as: 'Other Insurance',
                type: 'dropdown',
                options: [
                  {value: 'yes', text: 'Yes'},
                  {value: 'no', text: 'No'}
                ],
                do_not_show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: undefined
                  }
                ]
              },
              {
                key_path: [
                  'application',
                  'additional_data',
                  'name_of_other_plan'
                ],
                as: 'Name of Other Plan',
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: 'yes'
                  }
                ]
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup(),
          associatedGroup()
        ]
      }
    },
    berkleypostsecondary: {
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          {
            group_name: 'Insured Person',
            fields: [
              {
                key_path: ['search', 'first_name'],
                as: 'First Name'
              },
              {
                key_path: ['search', 'last_name'],
                as: 'Last Name'
              },
              {
                key_path: ['search', 'additional_data', 'student_id'],
                as: 'Student ID'
              },
              {
                key_path: ['search', 'dob'],
                as: 'Date of Birth',
                format: 'date'
              }
            ]
          },
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              ...schoolFields(),
              ...premiumField('0')
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(false)]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'spouse', text: 'Spouse'},
                  {value: 'chaperone', text: 'Chaperone'},
                  {value: 'teacher', text: 'Teacher'}
                ]
              },
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    studentvipinternationaloutofprovince: {
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          {
            group_name: 'Insured Person',
            fields: [
              {
                key_path: ['search', 'first_name'],
                as: 'First Name'
              },
              {
                key_path: ['search', 'last_name'],
                as: 'Last Name'
              },
              {
                key_path: ['search', 'additional_data', 'student_id'],
                as: 'Student ID'
              },
              {
                key_path: ['search', 'dob'],
                as: 'Date of Birth',
                format: 'date'
              }
            ]
          },
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              ...schoolFields(),
              ...premiumField('0')
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(false)]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              },
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleystudentvipshortterm: {
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: true,
          options: [
            {
              value: 'zip',
              label: 'Zip'
            },
            {
              value: 'email',
              label: 'Separate Emails'
            }
          ]
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          {
            group_name: 'Insured Person',
            fields: [
              {
                key_path: ['search', 'first_name'],
                as: 'First Name'
              },
              {
                key_path: ['search', 'last_name'],
                as: 'Last Name'
              },
              {
                key_path: ['search', 'additional_data', 'student_id'],
                as: 'Student ID'
              },
              {
                key_path: ['search', 'dob'],
                as: 'Date of Birth',
                format: 'date'
              }
            ]
          },
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [...applicantFields('0'), ...studentNumberFields('0')]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(true)]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              }
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleycpsa: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [...applicantFields('0'), ...premiumField('0')]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields()]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'travelling companion', text: 'Travelling Companion'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              },
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: ['application', 'additional_data', 'policy_type'],
                as: 'Policy Type',
                type: 'radio',
                options: [
                  {value: 'single trip', text: 'Single Trip'},
                  {value: 'multi-trip annual', text: 'Multi-Trip Annual'}
                ],
                is_static_by_default: true
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  }
                ],
                key_path: ['application', 'additional_data', 'destination'],
                as: 'Destination',
                type: 'dropdown',
                options: countries()
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'multi-trip annual'
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'number_of_days_per_trip'
                ],
                as: 'Number of Days per Trip',
                type: 'dropdown',
                options: [
                  {value: 4, text: '4 Days'},
                  {value: 9, text: '9 Days'},
                  {value: 16, text: '16 Days'},
                  {value: 31, text: '31 Days'},
                  {value: 60, text: '60 Days'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  }
                ],
                do_not_show_if: [
                  {
                    key_path: ['application', 'additional_data', 'destination'],
                    value: 'US'
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'travelling_through_the_us'
                ],
                as: 'Are applicants travelling through the US?',
                type: 'radio',
                options: [
                  {value: 'no', text: 'No'},
                  {value: 'yes', text: 'Yes'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'policy_type'],
                    value: 'single trip'
                  },
                  {
                    key_path: [
                      'application',
                      'additional_data',
                      'travelling_through_the_us'
                    ],
                    value: 'yes'
                  }
                ],
                key_path: [
                  'application',
                  'additional_data',
                  'number_of_travel_days_in_the_us'
                ],
                as: 'Number of Travel Days in the US'
              },
              {
                key_path: ['application', 'additional_data', 'deductible'],
                as: 'Deductible',
                type: 'dropdown',
                options: [
                  {value: 0, text: '$0.00 CAD'},
                  {value: 250, text: '$250.00 CAD'},
                  {value: 500, text: '$500.00 CAD'},
                  {value: 1000, text: '$1,000.00 CAD'},
                  {value: 5000, text: '$5,000.00 CAD'},
                  {value: 10000, text: '$10,000.00 CAD'}
                ]
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleycpsaallinclusive: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'membership_number'
                ],
                as: 'CPSA Membership Number',
                is_static_by_default: true
              }
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [
              ...basicContactFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'province_of_residence'
                ],
                as: 'Province',
                type: 'dropdown',
                options: provinces('CA')
              },
              {
                key_path: ['applicant', '0', 'postal_code'],
                as: 'Postal Code'
              }
            ]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'travelling companion', text: 'Travelling Companion'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              }
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: ['application', 'additional_data', 'trip_cost'],
                as: 'Trip Cost'
              },
              {
                key_path: [
                  'application',
                  'additional_data',
                  'trip_booked_date'
                ],
                as: 'Date the Trip was Booked',
                format: 'date'
              },
              {
                key_path: ['application', 'additional_data', 'destination'],
                as: 'Destination',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    shawsabeyis: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              {
                key_path: ['applicant', '0', 'additional_data', 'school_name'],
                as: 'School'
              },
              ...premiumField('0')
            ]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'parent', text: 'Parent'},
                  {value: 'spouse', text: 'Spouse'},
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'legal guardian', text: 'Legal Guardian'},
                  {value: 'teacher', text: 'Teacher'},
                  {value: 'chaperone', text: 'Chaperone'}
                ]
              },
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(false)]
          },

          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Home Country',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          detailedBeneficiaryGroup(),
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleyis: {
      defaultEmail: null,
      partial_skip_validation: true,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              {
                key_path: ['applicant', '0', 'additional_data', 'school_name'],
                as: 'School'
              },
              ...premiumField('0')
            ]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'travelling companion', text: 'Travelling Companion'},
                  {value: 'parent', text: 'Parent/Guardian'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              },
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(false)]
          },

          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: ['application', 'additional_data', 'coverage_type'],
                as: 'Plan Name',
                is_static_by_default: true
              },
              {
                key_path: [
                  'application',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Home Country',
                type: 'dropdown',
                options: countries()
              },
              {
                key_path: ['application', 'additional_data', 'other_plan'],
                as: 'Other Insurance',
                type: 'dropdown',
                options: [
                  {value: 'yes', text: 'Yes'},
                  {value: 'no', text: 'No'}
                ],
                do_not_show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: undefined
                  }
                ]
              },
              {
                key_path: [
                  'application',
                  'additional_data',
                  'name_of_other_plan'
                ],
                as: 'Name of Other Plan',
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: 'yes'
                  }
                ]
              }
            ]
          },
          detailedBeneficiaryGroup(),
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleycpsanonmedical: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'membership_number'
                ],
                as: 'CPSA Membership Number',
                is_static_by_default: true
              }
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [
              ...basicContactFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'province_of_residence'
                ],
                as: 'Province',
                type: 'dropdown',
                options: provinces('CA')
              },
              {
                key_path: ['applicant', '0', 'postal_code'],
                as: 'Postal Code'
              }
            ]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'travelling companion', text: 'Travelling Companion'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              }
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: ['application', 'additional_data', 'trip_cost'],
                as: 'Trip Cost'
              },
              {
                key_path: [
                  'application',
                  'additional_data',
                  'trip_booked_date'
                ],
                as: 'Date the Trip was Booked',
                format: 'date'
              },
              {
                key_path: ['application', 'additional_data', 'destination'],
                as: 'Destination',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    berkleydiscovercanada: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [...applicantFields('0')]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields()]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent'},
                  {value: 'travelling companion', text: 'Travelling Companion'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              }
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              },
              {
                key_path: ['application', 'additional_data', 'super_visa'],
                as: 'Are applicants travelling to Canada on a Super Visa?',
                type: 'radio',
                options: [
                  {value: 'no', text: 'No'},
                  {value: 'yes', text: 'Yes'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'super_visa'],
                    value: 'yes'
                  }
                ],
                key_path: ['application', 'additional_data', 'coverage'],
                as: 'Coverage',
                type: 'dropdown',
                options: [
                  {value: 100000, text: '$100,000.00 CAD'},
                  {value: 150000, text: '$150,000.00 CAD'},
                  {value: 300000, text: '$300,000.00 CAD'},
                  {value: 500000, text: '$500,000.00 CAD'},
                  {value: 1000000, text: '$1,000,000.00 CAD'}
                ]
              },
              {
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'super_visa'],
                    value: 'no'
                  }
                ],
                key_path: ['application', 'additional_data', 'coverage'],
                as: 'Coverage',
                type: 'dropdown',
                options: [
                  {value: 50000, text: '$50,000.00 CAD'},
                  {value: 100000, text: '$100,000.00 CAD'},
                  {value: 150000, text: '$150,000.00 CAD'},
                  {value: 300000, text: '$300,000.00 CAD'},
                  {value: 500000, text: '$500,000.00 CAD'},
                  {value: 1000000, text: '$1,000,000.00 CAD'}
                ]
              },
              {
                key_path: ['application', 'additional_data', 'deductible'],
                as: 'Deductible',
                type: 'dropdown',
                options: [
                  {value: 0, text: '$0.00 CAD'},
                  {value: 100, text: '$100.00 CAD'},
                  {value: 250, text: '$250.00 CAD'},
                  {value: 500, text: '$500.00 CAD'},
                  {value: 1000, text: '$1,000.00 CAD'},
                  {value: 3000, text: '$3,000.00 CAD'},
                  {value: 5000, text: '$5,000.00 CAD'},
                  {value: 10000, text: '$10,000.00 CAD'},
                  {value: 25000, text: '$25,000.00 CAD'}
                ]
              }
            ]
          },
          beneficiaryGroup(),
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    explorecanadais: {
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              ...studentNumberFields('0'),
              ...premiumField('0'),
              {
                key_path: ['application', 'associated_policy'],
                as: 'Associated Student Policy',
                do_not_show_if: [
                  {
                    key_path: ['application', 'associated_policy'],
                    value: null
                  }
                ],
                is_static_by_default: false
              },
              {
                key_path: [
                  'applicant',
                  '0',
                  'additional_data',
                  'relationship_to_student'
                ],
                as: 'Relationship to Student',
                do_not_show_if: [
                  {
                    key_path: ['application', 'associated_policy'],
                    value: null
                  }
                ],
                is_static_by_default: false,
                type: 'dropdown',
                options: [
                  {value: 'parent', text: 'Parent/Guardian'},
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              }
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(false)]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'parent', text: 'Parent/Guardian'},
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              },
              ...studentNumberFields('*'),
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              },
              {
                key_path: ['application', 'additional_data', 'other_plan'],
                as: 'Other Insurance',
                type: 'dropdown',
                options: [
                  {value: 'yes', text: 'Yes'},
                  {value: 'no', text: 'No'}
                ],
                do_not_show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: undefined
                  }
                ]
              },
              {
                key_path: [
                  'application',
                  'additional_data',
                  'name_of_other_plan'
                ],
                as: 'Name of Other Plan',
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: 'yes'
                  }
                ]
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup(),
          associatedGroup()
        ]
      }
    },
    studycanadais: {
      defaultEmail: null,
      partial_skip_validation: false,
      hidePremium: true,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: null,
          link: null
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              ...studentNumberFields('0'),
              ...premiumField('0')
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(true)]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'parent', text: 'Parent/Guardian'},
                  {value: 'spouse', text: 'Spouse'}
                ]
              },
              ...studentNumberFields('*'),
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Country of Origin',
                type: 'dropdown',
                options: countries()
              },
              {
                key_path: ['application', 'additional_data', 'other_plan'],
                as: 'Other Insurance',
                type: 'dropdown',
                options: [
                  {value: 'yes', text: 'Yes'},
                  {value: 'no', text: 'No'}
                ],
                do_not_show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: undefined
                  }
                ]
              },
              {
                key_path: [
                  'application',
                  'additional_data',
                  'name_of_other_plan'
                ],
                as: 'Name of Other Plan',
                show_if: [
                  {
                    key_path: ['application', 'additional_data', 'other_plan'],
                    value: 'yes'
                  }
                ]
              }
            ]
          },
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    },
    lloydsshawsabeyis: {
      defaultEmail: null,
      partial_skip_validation: false,
      upload_path: [
        {
          canUpload: false
        }
      ],
      form_path: [
        {
          name: 'Application Form',
          link: '%s/v2/lloyds/shaw-sabey'
        }
      ],
      configuration_form: {
        compact: [
          policyGroupCompact(),
          insuredPersonGroupCompact(),
          detailsGroupCompact('Referrer')
        ],
        expanded: [
          policyGroup('Referrer'),
          {
            group_name: 'Primary Insured Person',
            check_history: true,
            fields: [
              ...applicantFields('0'),
              {
                key_path: ['applicant', '0', 'additional_data', 'school_name'],
                as: 'School'
              },
              ...premiumField('0')
            ]
          },
          {
            group_name: 'Contact Information',
            check_history: true,
            fields: [...basicContactFields(), ...legalGuardianFields(false)]
          },
          {
            group_name: 'Insured Person *++',
            check_history: true,
            repeat: {
              start: 1,
              key_path: ['applicant']
            },
            fields: [
              ...applicantFields('*'),
              {
                key_path: [
                  'applicant',
                  '*',
                  'additional_data',
                  'relationship_to_primary_applicant'
                ],
                as: 'Relationship to Primary Applicant',
                type: 'dropdown',
                options: [
                  {value: 'parent', text: 'Parent'},
                  {value: 'spouse', text: 'Spouse'},
                  {value: 'dependent', text: 'Dependent Child'},
                  {value: 'legal guardian', text: 'Legal Guardian'},
                  {value: 'teacher', text: 'Teacher'},
                  {value: 'chaperone', text: 'Chaperone'}
                ]
              },
              ...studentNumberFields('*'),
              ...premiumField('*')
            ]
          },
          {
            group_name: 'Coverage Details',
            check_history: true,
            fields: [
              ...basicCoverageFields(),
              {
                key_path: [
                  'application',
                  'additional_data',
                  'country_of_origin'
                ],
                as: 'Home Country',
                type: 'dropdown',
                options: countries()
              }
            ]
          },
          detailedBeneficiaryGroup(),
          paymentGroup(),
          fulfillmentGroup(),
          historyGroup()
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/clients/deprecated.js